if (!window.handlePublicTemplateOpenUrl) {
  window.handlePublicTemplateOpenUrl = function(event) {
    event.preventDefault();
    event.stopPropagation();
    let otherWindowUrl = window.open();
    otherWindowUrl.opener = null;
    otherWindowUrl.target =  '_blank';
    otherWindowUrl.location = event.target.href;
    return;
  }
}